import { Injectable } from '@angular/core';
// import * as cryptoJS from 'crypto-js';


const USER = 'login_user';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}


//   Hash 256 Encryption function
//    sha256(input: string): string {
//     const hash = cryptoJS.SHA256(input);
//     return hash.toString(cryptoJS.enc.Hex);
//   }


  clean(): void {
    window.sessionStorage.clear();
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER);
    window.sessionStorage.setItem(USER, JSON.stringify(user));
    localStorage.setItem('user_details',JSON.stringify(user))
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return true;
    }
    return false;
  }
}